import { render } from "./CreateUserPage.vue?vue&type=template&id=3f86b7a9&ts=true"
import script from "./CreateUserPage.vue?vue&type=script&lang=ts"
export * from "./CreateUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/CreateUserPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f86b7a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f86b7a9', __exports__)) {
    api.reload('3f86b7a9', __exports__)
  }
  
  module.hot.accept("./CreateUserPage.vue?vue&type=template&id=3f86b7a9&ts=true", () => {
    api.rerender('3f86b7a9', render)
  })

}


export default __exports__